"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MarketplaceRepository_1 = __importDefault(require("../repositories/MarketplaceRepository"));
var MarketplaceService = /** @class */ (function () {
    function MarketplaceService() {
    }
    /**
     * @TODO remove that when the endpoint will be DONE
     * https://easyorder.atlassian.net/browse/EOAPP-3343
     * @returns {Promise<Array<Location>>}
     * @param id
     */
    MarketplaceService.getSuggestedLocations = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var locations, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, MarketplaceRepository_1.default.getSuggestedLocations(id)];
                    case 1:
                        locations = _a.sent();
                        return [2 /*return*/, Promise.resolve(locations)];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MarketplaceService.getMarketplaceNews = function (id, limit) {
        if (limit === void 0) { limit = 5; }
        return __awaiter(this, void 0, void 0, function () {
            var news, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, MarketplaceRepository_1.default.getMarketplaceNews(id, limit)];
                    case 1:
                        news = _a.sent();
                        return [2 /*return*/, Promise.resolve(news)];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_2)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MarketplaceService.getMarketplaceNewsById = function (marketplaceId, newsId) {
        return __awaiter(this, void 0, void 0, function () {
            var news, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, MarketplaceRepository_1.default.getMarketplaceNewsById(marketplaceId, newsId)];
                    case 1:
                        news = _a.sent();
                        return [2 /*return*/, Promise.resolve(news)];
                    case 2:
                        e_3 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_3)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MarketplaceService.getMarketplaceCategories = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var categories, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, MarketplaceRepository_1.default.getMarketplaceCategories(id)];
                    case 1:
                        categories = _a.sent();
                        return [2 /*return*/, Promise.resolve(categories)];
                    case 2:
                        e_4 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_4)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MarketplaceService.getMarketplaceLocation = function (id, locationId) {
        return __awaiter(this, void 0, void 0, function () {
            var location_1, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, MarketplaceRepository_1.default.getMarketplaceLocation(id, locationId)];
                    case 1:
                        location_1 = _a.sent();
                        return [2 /*return*/, Promise.resolve(location_1)];
                    case 2:
                        e_5 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_5)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MarketplaceService.getMarketplaceLocations = function (id, categoryId, searchValue, filters, page, maxItemsPerPage) {
        return __awaiter(this, void 0, void 0, function () {
            var locations, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, MarketplaceRepository_1.default.getMarketplaceLocations(id, categoryId, searchValue, filters, page, maxItemsPerPage)];
                    case 1:
                        locations = _a.sent();
                        return [2 /*return*/, Promise.resolve(locations)];
                    case 2:
                        e_6 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_6)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MarketplaceService.getMarketplaceFilters = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var filters, e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, MarketplaceRepository_1.default.getMarketplaceFilters(id)];
                    case 1:
                        filters = _a.sent();
                        return [2 /*return*/, Promise.resolve(filters)];
                    case 2:
                        e_7 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_7)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return MarketplaceService;
}());
exports.default = MarketplaceService;
